import {
  ContainerBox,
  Datenschutz,
  HeaderInterface
} from '@peakconcepts/landingpage-kit'
import seoHeaderData from './data/seoHeader'

import leadData from './data/lead'
import leadRecruitingData from './data/leadRecruiting'
import leadImmoData from './data/leadImmo'
import imprintData from './data/imprint'
import policyData from './data/policy'
import termsData from './data/terms'

export const headerConfig: HeaderInterface = {
  withContainer: true,
  containerConfig: {
    padding: {
      fullHd: '20px 0',
      widescreen: '20px 0',
      desktop: '20px 0',
      tablet: '20px 0',
      mobile: '10px 0'
    }
  },
  brandConfig: {
    className: 'ml-0',
    defaultCss: { justifyContent: 'center' },
    imageContainer: {
      className: 'p-0'
    },
    image: {
      src: '/images/logo-black.png',
      width: '120px',
      defaultCss: {
        maxHeight: 'unset !important'
      }
    }
  },
  burgerConfig: {
    hide: true
  }
}

const data = [
  {
    path: '/impressum',
    headerEnabled: true,
    seoHeaderConfig: seoHeaderData.imprint,
    headerConfig,
    component: ContainerBox,
    data: {
      ...imprintData
    }
  },
  {
    path: '/datenschutz',
    headerEnabled: true,
    seoHeaderConfig: seoHeaderData.policy,
    headerConfig,
    component: Datenschutz,
    data: {
      ...policyData
    }
  },
  {
    path: '/agbs',
    headerEnabled: true,
    seoHeaderConfig: seoHeaderData.terms,
    headerConfig,
    component: ContainerBox,
    data: {
      ...termsData
    }
  },
  {
    id: 'Danke',
    path: '/danke',
    headerEnabled: true,
    seoHeaderConfig: seoHeaderData.thankYou,
    headerConfig,
    component: ContainerBox,
    data: {
      ...leadData
    }
  },
  {
    id: 'Danke',
    path: '/immobilienmakler/danke',
    headerEnabled: true,
    seoHeaderConfig: seoHeaderData.thankYou,
    headerConfig,
    component: ContainerBox,
    data: {
      ...leadImmoData
    }
  },
  {
    id: 'Danke',
    path: '/recruiting/danke',
    headerEnabled: true,
    seoHeaderConfig: seoHeaderData.thankYou,
    headerConfig,
    component: ContainerBox,
    data: {
      ...leadRecruitingData
    }
  }
]

export default data
